export default __webpack_public_path__ + "static/media/qsLogo.9c42fbf2.jpg";